import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import BarraCP from '../../../components/BarCP/BarHeaderCP';
import MenuPrincipal from '../../../../../../components/Menu';
import CartHeaderCount from '../../../components/Cart/CartHeaderCount';
import SearchModule from '../../../components/SearchHeader';
import { HeaderWishlist } from '../../../components/Header/HeaderWishlist';
import { HeaderMisPedidos } from '../../../components/Header/HeaderMisPedidos';
import { HeaderMiCuenta } from '../../../components/Header/HeaderMiCuenta';
import { CategoryMenuHeader } from '../../../components/Header/CategoryMenuHeader';
import { HeaderTiendasMenu } from '../../../components/Header/MenuTiendas';
import { HeaderPromo } from '../../../components/Header/PromoHeader';
import { ErrorBoundary } from '../../../components/Error/ErrorBoundary';
import { useStorage64 } from 'hooks/useStorageBase64';

export function HeaderDesktop(props) {
    const {
        isLoged,
        totalItems,
        profile,
        changeDirectionBar,
        searchWork
    } = props;

    const [showModal, SetShowModal] = useState(false)
    const [dataFace] = useStorage64('dataFacebook', '')
    const [nombre0, setnombre0] = useState("")
    const hostName = window.location.origin
    const urlLink = window.location.href;
    const history = useHistory();

    //- Funciones para activar o desactivar el modal del menu lateral
    const showMenu = () => { SetShowModal(true); }
    const handleClose = () => { SetShowModal(false); }

    const desktopView = () => document.querySelector('#root').classList.add('desktopView');

    useEffect(() => {
        desktopView();
    }, [])

    let nombreArray = [];
    useEffect(() => {
        if (profile.nombre) {
            nombreArray = profile.nombre.split(' ');
            setnombre0(nombreArray[0]);
        }
    }, [profile])
    
    useEffect(() => {
        if (isLoged && dataFace.name) {
            nombreArray = dataFace.name.split(' ');
            setnombre0(nombreArray[0]);
        }
    }, [dataFace])


    return (
        <>
            <header className='no-printme '>
                <div className="headerSup">
                    <div className="container">
                        <a href="/" className="logoClaroshop" aria-label="logoClaroShop"></a>

                        <ErrorBoundary>
                            <BarraCP changeCP={changeDirectionBar} clase="barHeaderCP" />
                        </ErrorBoundary>

                        <ErrorBoundary>
                            <SearchModule {...props} searchWork={searchWork} />
                        </ErrorBoundary>

                        <div className="menuPrincipal">
                            <div className="menuDesk">
                                <ErrorBoundary>
                                    <HeaderWishlist ruta={isLoged ? '/mi-cuenta/listadeseos/' : `/login?redirect=${hostName}/mi-cuenta/listadeseos/`} />
                                </ErrorBoundary>

                                <ErrorBoundary>
                                    <HeaderMisPedidos ruta={isLoged ? '/mi-cuenta/mis-pedidos/dias=30/pagina=1' : `/login?redirect=${hostName}/mi-cuenta/mis-pedidos/dias=30/pagina=1`} />
                                </ErrorBoundary>

                                <ErrorBoundary>
                                    <HeaderMiCuenta ruta={isLoged ? '/mi-cuenta' : `/login?redirect=${hostName}/mi-cuenta`} profile={profile} />
                                </ErrorBoundary>


                                <ErrorBoundary>
                                    <CartHeaderCount ruta={isLoged ? '/carrito/detalle' : `/login?redirect=${hostName}/carrito/detalle`} cantidad={isLoged ? totalItems : 0} />
                                </ErrorBoundary>
                            </div>
                            {/* <HeaderBarMovile isLoged={isLoged} profile={profile} /> */}
                        </div>

                    </div>
                </div>
                <div className="headerInf">
                    <div className="container">
                        <ErrorBoundary>
                            <CategoryMenuHeader />
                        </ErrorBoundary>

                        <HeaderPromo />
                        <HeaderTiendasMenu />
                    </div>
                </div>


                <div className="headerMobile">
                    <div onClick={showMenu} className="menuLateral" aria-label="Menu Principal"></div>
                    <a href="/" className="logoClaroshop" aria-label="logoClaroshop"></a>

                    <div className="contentLogin">
                        <ErrorBoundary>
                            {isLoged && (profile || dataFace)
                                ?
                                <a href="/mi-cuenta" className="icoMiCuenta navBar" title="Mi Cuenta"><span>{String(nombre0).length > 8 ? <>{String(nombre0).substring(0, 7)} ...</> : String(nombre0)}</span></a>
                                :
                                <a href={`/login?redirect=${urlLink}`} className="icoMiCuenta navBar" title="Mi Cuenta"></a>
                            }
                        </ErrorBoundary>

                        <ErrorBoundary>
                            <CartHeaderCount ruta={isLoged ? '/carrito/detalle' : `/login?redirect=${hostName}/carrito/detalle`} cantidad={isLoged ? totalItems : 0} />
                        </ErrorBoundary>
                    </div>
                </div>
            </header>

            {showModal && <MenuPrincipal onClose={handleClose} />}
        </>
    )
}